var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1323 23.5301C16.3224 23.5301 20.5298 19.3227 20.5298 14.1326C20.5298 8.9425 16.3224 4.73511 11.1323 4.73511C5.94226 4.73511 1.73486 8.9425 1.73486 14.1326C1.73486 19.3227 5.94226 23.5301 11.1323 23.5301Z",
    stroke: "#8A6857",
    strokeWidth: 1.8795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1323 17.0881V12.9998",
    stroke: "#8A6857",
    strokeWidth: 1.8795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1323 8.91187H11.1424",
    stroke: "#8A6857",
    strokeWidth: 1.8795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.169cc0f2560a353d2d4d63ea202d4c30.svg";
export { ForwardRef as ReactComponent };